import { Box, BoxProps } from '@mui/material'

const Item = (props: BoxProps) => {
  const { sx, ...other } = props
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        fontSize: '0.875rem',
        fontWeight: 'Inter',
        ...sx
      }}
      {...other}
    />
  )
}

export default Item
